import { render, staticRenderFns } from "./PlaceLaPaz.vue?vue&type=template&id=43cebecb&scoped=true&"
import script from "./PlaceLaPaz.vue?vue&type=script&lang=js&"
export * from "./PlaceLaPaz.vue?vue&type=script&lang=js&"
import style0 from "./PlaceLaPaz.vue?vue&type=style&index=0&id=43cebecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cebecb",
  null
  
)

export default component.exports